const BEIJING_TIME_ZONE = "Asia/Shanghai";

type BeijingDateParts = {
  year: number;
  month: number;
  day: number;
  hour: number;
};

/** 将后端无时区时间按北京时间解析。 */
function parseBackendDateTime(value?: string): Date | null {
  const normalized = value?.trim();
  if (!normalized) {
    return null;
  }
  const isoLike = normalized.includes("T") ? normalized : normalized.replace(" ", "T");
  const withZone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(isoLike) ? isoLike : `${isoLike}+08:00`;
  const date = new Date(withZone);
  return Number.isNaN(date.getTime()) ? null : date;
}

/** 提取指定时刻对应的北京时间日历字段。 */
function getBeijingDateParts(date: Date): BeijingDateParts {
  const parts = new Intl.DateTimeFormat("zh-CN", {
    timeZone: BEIJING_TIME_ZONE,
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    hourCycle: "h23",
  }).formatToParts(date);
  const values = Object.fromEntries(
    parts.filter((part) => part.type !== "literal").map((part) => [part.type, Number(part.value)]),
  );
  return {
    year: values.year,
    month: values.month,
    day: values.day,
    hour: values.hour,
  };
}

/** 将时间显示为 M月D日H点，隐藏年、分和秒。 */
export function formatBeijingCompactTime(value?: string): string {
  const date = parseBackendDateTime(value);
  if (!date) {
    return "--";
  }
  const parts = getBeijingDateParts(date);
  return `${parts.month}月${parts.day}日${parts.hour}点`;
}

/** 判断后端时间是否属于当前北京时间自然日。 */
export function isBeijingToday(value?: string, now = new Date()): boolean {
  const date = parseBackendDateTime(value);
  if (!date || Number.isNaN(now.getTime())) {
    return false;
  }
  const target = getBeijingDateParts(date);
  const current = getBeijingDateParts(now);
  return (
    target.year === current.year &&
    target.month === current.month &&
    target.day === current.day
  );
}
